import React from 'react';
import { CheckPicker } from 'rsuite';

export function FiltroExperiencias(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <CheckPicker {...props} placeholder="Experiencias" />;
}
